import React, { useCallback } from 'react'

import { useEventHandler } from 'tyan/public/hooks'
import ButtonSpan from './ButtonSpan'

const IconButton = props => {
	const { onFocus, value, fontSize, button: {
		_button, text = _button, icon = 'ellipsis-h', hidden, disabled: buttonDisabled, handler, cdt, ui
	} = {} } = props

	const handleMouseDown = useCallback(event => {
		onFocus && onFocus()
		event.target.classList.add('e-input-btn-ripple')
	}, [])

	const handleMouseUp = useCallback(event => {
		const target = event.target
		setTimeout(() => target.classList.remove('e-input-btn-ripple'), 500)
	}, [])

	const handleClick = useEventHandler(event => {
		handler && handler(value)
	})

	const className = ['e-input-group-icon t-input-group-icon e-icons']
		// .concat(`t-${icon}-icon-before`)
		.concat(`t-fa fa-${icon || 'ellipsis-h'}`)
		.concat(/* disabled ||  */buttonDisabled ? 't-input-icon-disabled' : 't-input-icon-enabled')
		.concat(hidden ? 't-input-icon-hidden' : [])
		.concat(ui ? `t-${ui}` : [])
		.join(' ')

	return (!cdt || cdt()) ? <ButtonSpan className={className}
		{...(text ? { 'data-qtip': text, 'data-qanchor': true } : {})}
		{.../* disabled ||  */buttonDisabled ? {} : { onClick: handleClick, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp }}
	/> : null
}

export default IconButton